import React from 'react'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import SButton from '@/components/common/SButton'
import PlusBoxSVG from '@/images/home/PlusBox.svg?react'
import { useCreateEvent } from '@/contexts/create-event-context'

// Full class sets per surface (like BookACallButton) so no two `!` overrides compete.
const VARIANTS = {
    // Home category bar + side menu user row (kit .nav-create look): ink fill, radius 5, the chips' 32px.
    bar: 'h-8! p-[4px]! pr-[14px]! rounded-[5px]! font-normal! border bg-(--btn-bg)! shrink-0',
    // Mobile side menu (kit .mmenu-btn): full-width ink row, 44px touch target, radius 10.
    menu: 'h-11! w-full px-3.5! gap-[9px]! rounded-[10px]! text-[14.5px]! font-normal! border-0 bg-(--btn-bg)!',
}

/**
 * "Create an Event" (mock [data-create]): opens the modal in place when logged in; logged out, the
 * context sends the visitor through the login to My Events, which opens it on arrival. Translates
 * itself from the navbar namespace so any surface (side menu, home bar) can drop it in.
 */
export default function CreateEventButton({ variant = 'bar', className = '', onBeforeOpen, ...rest }) {
    const { t } = useTranslation(TranslationNS.NAVBAR)
    const { open } = useCreateEvent()

    return (
        <SButton
            value={t('Create an Event')}
            Icon={PlusBoxSVG}
            iconLocation="left"
            onClick={() => {
                onBeforeOpen?.()
                open()
            }}
            className={`${VARIANTS[variant] || VARIANTS.bar} ${className}`}
            {...rest}
        />
    )
}
